import React from "react";
import {
    Box,
    Grid,
    Paper,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Button,
    DialogActions
} from "@mui/material";
import { Chip, Table } from "@mui/joy";
import { PolicyPdfReport } from "../ReportGenerationComponents/PolicyPdfReport";
import * as apiUtility from "../../config/APIUtils";
import { BsFiletypePdf } from "react-icons/bs";


export default function PolicyReviewComponent({ open, onClose, policyData, history }) {

    //const { userData, roleDetail, homeDetail } = useUser();
    var userDetails = {};
    const handleDownloadPDF = async () => {
        
        userDetails["homeName"] = policyData.home_id;
        userDetails["roleName"] = policyData.roleName;
        userDetails["firstName"] = policyData.firstName;
        userDetails["lastName"] = policyData.lastName;
        userDetails["user_id"] = policyData.user_id;
        userDetails["dob"] = policyData.dob;


        await PolicyPdfReport(userDetails, history.policyData, 'Home Doc History', 'Carepassport_HomeDocHistory_' + policyData.policyData.policyId + "_" + policyData?.user_id, false);
    };

    function reassignPolicy(){
        if(policyData.user_id  && policyData.home_id && policyData.policyData.length!=0){
            console.log(policyData.policyData[0].policyId)
             var apiRequest = apiUtility.apiInputRequest;
        apiRequest.endPoint = "policy/reassignPolicyForUser";
        apiRequest.data = { home_id: policyData.home_id, user_id: policyData.user_id, policyId: policyData.policyData[0].policyId, role_id: policyData.role_id};
        console.log(apiRequest.data)
        apiUtility.updateAsyncAPIDataPUT(apiRequest).then(res => {
          //  console.log(res.data);
             onClose();
            
        }).catch((error) => {
            console.error(error);
            alert("Something Went Wrong!")
        });
        }
        
    }

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                maxWidth="lg"
                fullWidth
                disableScrollLock={true}
                PaperProps={{ sx: { borderRadius: 3, p: 1 } }}
            >
                <DialogTitle variant="body1">Home Doc History</DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <Typography variant="h6" gutterBottom>
                            </Typography>

                            <Box sx={{ mt: 2 }}>
                                {[
                                    // { label: "Title", value: policyData.title },
                                    // { label: "Type", value: policyData.type },
                                    // { label: "Description", value: policyData.description },
                                    { label: "User ID", value: policyData?.user_id },
                                    { label: "Home ", value: policyData?.home_id },
                                    { label: "Role ", value: policyData?.roleName },

                                ].map((field, index) => (
                                    <Box
                                        key={field.label}
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'start',
                                            mb: 2,
                                            "&:last-child": { mb: 0 }
                                        }}
                                    >
                                        <Typography
                                            variant="body2"
                                            color="primary"
                                            sx={{
                                                minWidth: '120px',
                                                pt: 0.5
                                            }}
                                        >
                                            {field.label}:
                                        </Typography>
                                        <Typography variant="body2">
                                            {field.value || "N/A"}
                                        </Typography>
                                    </Box>
                                ))}
                            </Box>

                        </Grid>

                        <Grid item xs={12} md={8}>

                            <Typography variant="h6">
                                History
                                 <IconButton color="primary" title="Download Home Doc History"  onClick={handleDownloadPDF}  sx={{ p: '8px' }} aria-label="directions">
                                    <BsFiletypePdf />
                                </IconButton>
                                
                            </Typography>
                            <Box sx={{ mt: 2 }}>

                                <Table
                                    borderAxis="bothBetween"
                                    stripe="odd"
                                    hoverRow
                                    sx={{ minWidth: 700 }}
                                >
                                    <thead>
                                        <tr>
                                            <th>Doc Code</th>
                                            <th>Version</th>
                                            <th>Completion Date</th>
                                            <th>Expiry Date</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(history.policyData?.length > 0) ?
                                            history.policyData.map((row) => (
                                                <tr key={row._id}>
                                                    <td>{row.policyId}</td>
                                                    <td>{row.policyNumber}</td>
                                                    <td>
                                                        {new Date(row.completion_date).toLocaleDateString()}
                                                    </td>
                                                    <td>
                                                        {(row.expiry_date != "") ? new Date(row.expiry_date).toLocaleDateString() : "N/A"}
                                                    </td>
                                                    <td>
                                                        <Chip
                                                            color={row.verification === "Validated" ? "success" : "warning"}
                                                            variant="soft"
                                                            size="sm"
                                                        >
                                                            {row.expiry_reason && row.expiry_reason!=""?
                                                            row.expiry_reason
                                                            // +"("+row.expiry_date+")"
                                                            :row.verification}
                                                        </Chip>
                                                    </td>
                                                </tr>
                                            ))
                                            : <td colSpan={5} style={{ "text-align": "center" }}>No history available</td>
                                        }
                                    </tbody>
                                </Table>
                            </Box>

                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Close</Button>
                     {(history.policyData?.length > 0 && history.policyData[0].expiry_reason && history.policyData[0].expiry_reason=="D0C - REASSIGNED") ?
                        <div></div>:<Button onClick={reassignPolicy}>Re-Assign</Button>
    }
                    
                </DialogActions>
            </Dialog>

        </>
    );
}
